import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@fontsource-variable/space-grotesk';
import '@fontsource-variable/ibm-plex-sans';
import '@fontsource/ibm-plex-mono/latin-500.css';
import './index.css'; // Your global CSS with Tailwind directives
import App from './App'; // Corrected import for App.tsx
import reportWebVitals from './reportWebVitals';

declare global {
  interface Window {
    __HYDRATION_ERRORS__?: string[];
    __APP_READY__?: boolean;
  }
}

const container = document.getElementById('root') as HTMLElement;

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Prerendered pages arrive with markup in #root and must be hydrated; the dev server
// and any un-prerendered route (/blog/:slug) still get a fresh render.
if (container.hasChildNodes()) {
  hydrateRoot(container, app, {
    onRecoverableError(error) {
      (window.__HYDRATION_ERRORS__ ??= []).push(String(error));
      console.error(error);
    },
  });
} else {
  createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
